import { z } from 'zod';
import {
  ColumnElementSchema,
  RowElementSchema,
  DescriptionElementSchema,
  H1ElementSchema,
  H3ElementSchema,
  H4ElementSchema,
  DividerElementSchema,
  SubmitButtonElementSchema,
} from './ui';
import { AutocompleteFieldElementSchema } from './fields/autocomplete';
import { CheckboxFieldElementSchema } from './fields/checkbox';
import {
  CheckboxListElementSchema,
  CountryPickerFieldElementSchema,
  DateFieldElementSchema,
  DocumentFieldElementSchema,
  EntityFieldGroupElementSchema,
  FieldListElementSchema,
  FileFieldElementSchema,
  IndustriesPickerFieldElementSchema,
  LocalePickerFieldElementSchema,
  MCCPickerFieldElementSchema,
  MultiSelectFieldElementSchema,
  NationalityPickerFieldElementSchema,
  PhoneFieldElementSchema,
  RadioFieldElementSchema,
  SelectFieldElementSchema,
  StatePickerFieldElementSchema,
  TagsFieldElementSchema,
  TaxIdPickerFieldElementSchema,
  TextFieldElementSchema,
} from './fields';

export const UIElementsSchema = z.discriminatedUnion('element', [
  ColumnElementSchema,
  RowElementSchema,
  DescriptionElementSchema,
  H1ElementSchema,
  H3ElementSchema,
  H4ElementSchema,
  DividerElementSchema,
  AutocompleteFieldElementSchema,
  CheckboxFieldElementSchema,
  CheckboxListElementSchema,
  DateFieldElementSchema,
  CountryPickerFieldElementSchema,
  DocumentFieldElementSchema,
  FieldListElementSchema,
  EntityFieldGroupElementSchema,
  FileFieldElementSchema,
  MultiSelectFieldElementSchema,
  PhoneFieldElementSchema,
  RadioFieldElementSchema,
  SelectFieldElementSchema,
  TagsFieldElementSchema,
  TextFieldElementSchema,
  IndustriesPickerFieldElementSchema,
  LocalePickerFieldElementSchema,
  MCCPickerFieldElementSchema,
  NationalityPickerFieldElementSchema,
  StatePickerFieldElementSchema,
  TaxIdPickerFieldElementSchema,
  SubmitButtonElementSchema,
]);

export const UIElementsSchemaWithChildren: z.ZodType<any> = z.intersection(
  UIElementsSchema,
  z.object({
    children: z.lazy(() => z.array(UIElementsSchemaWithChildren)).optional(),
  }),
);

export type TUIElements = z.infer<typeof UIElementsSchema>['element'];

export type TUIElement = z.infer<typeof UIElementsSchema> & {
  children?: TUIElement[];
};

export type GetElementByType<T, K extends string> = T extends { element: K } ? T : never;

export type GetUIElementByType<T extends string> = GetElementByType<TUIElement, T>;
